import * as React from 'react';
import { useFormik } from 'formik';
import { Constants, Validators } from 'core';
import { ProductCode, RequestError } from 'types';

import { useIntl } from 'common/config/i18n';
import FormError from 'components/molecules/form-error';
import { StyledRepositoryForm, StyledRepositoryFormButtonWrapper } from 'common/styling/mixins';
import Button from 'components/molecules/button';
import Input from 'components/organisms/input';

interface Props {
  onSubmit: (values: ProductCode) => void;
  productCode?: ProductCode;
  error?: RequestError;
  status?: 'loading' | 'error' | 'success';
}

const Form = (props: Props) => {
  const { t } = useIntl();

  const initialValues = {
    name: props.productCode && props.productCode.name ? props.productCode.name : '',
  };
  const formik = useFormik({
    initialValues,
    validate: (values) => Validators.formProductCode(values),
    onSubmit: (values) => {
      props.onSubmit(values);
    },
  });

  return (
    <StyledRepositoryForm onSubmit={formik.handleSubmit}>
      <div className="formSection">
        <Input
          upLabel={t('form', 'CHART_PRODUCT_CODE')}
          name="name"
          onChange={formik.handleChange}
          value={formik.values.name}
          width="100%"
        />
        <FormError formik={formik} fieldName="name" />
      </div>

      <StyledRepositoryFormButtonWrapper>
        <Button
          height="35px"
          width="100%"
          borderRadius="20px"
          disabled={!!(formik.errors.name && formik.touched.name)}
          htmlType="submit"
          loading={props.status === 'loading'}
        >
          {t('Buttons', 'CREATE_BUTTON')}
        </Button>
      </StyledRepositoryFormButtonWrapper>
      {props.error && (
        <FormError
          message={
            props.error === Constants.ALREADY_EXISTED_PROBLEM_CODE
              ? t('form', 'FORM_PRODUCT_CODE_ALLREADY_EXIST')
              : t('form', 'FORM_UNKNOWN_ERROR')
          }
        />
      )}
    </StyledRepositoryForm>
  );
};
export default Form;
